import { ActionReducerMapBuilder, createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FETCH_OPENING_GROUPS_SUCCESS } from '../../actions/drawable'
import { OpeningGroupAPI } from '../../models/activeDrawable'
import { DRAWABLE_TYPES } from '../../shared/constants/drawable-types'
import { RootState } from '../../stores'

export type HighlightsState = {
    highlightOpeningGroups: OpeningGroupAPI[] | null
}

export const initialHighlightsState: HighlightsState = {
    highlightOpeningGroups: null,
}

export const gotOpeningGroups = createAction<OpeningGroupAPI[]>(FETCH_OPENING_GROUPS_SUCCESS)

function handleSetHighlightGroups(state: HighlightsState, { payload }: PayloadAction<OpeningGroupAPI[]>) {
    state.highlightOpeningGroups = payload.filter((group) => group.type === DRAWABLE_TYPES.HIGHLIGHTER)
}

function handleAddHighlightGroup(state: HighlightsState, { payload }: PayloadAction<OpeningGroupAPI>) {
    if (state.highlightOpeningGroups === null) {
        state.highlightOpeningGroups = [payload]

        return
    }

    const highlightExist = state.highlightOpeningGroups.some((highlight) => highlight.id === payload.id)

    if (!highlightExist) {
        state.highlightOpeningGroups = [...state.highlightOpeningGroups, payload]

        return
    }

    state.highlightOpeningGroups = state.highlightOpeningGroups.map((highlight) => {
        if (highlight.id === payload.id) {
            return payload
        }

        return highlight
    })
}

const extraReducers = (builder: ActionReducerMapBuilder<HighlightsState>): void => {
    builder.addCase(gotOpeningGroups, handleSetHighlightGroups)
}

const highlightsSlice = createSlice({
    name: 'highlights',
    initialState: initialHighlightsState,
    reducers: {
        setHighlightGroups: handleSetHighlightGroups,
        addHighlightGroup: handleAddHighlightGroup,
    },
    extraReducers,
})

export const { addHighlightGroup } = highlightsSlice.actions

export const selectHighlights = createSelector(
    ({ IMUP }: RootState) => IMUP.highlights.highlightOpeningGroups,
    (highlightOpeningGroups) => highlightOpeningGroups
)

export default highlightsSlice
